import React from 'react';
import { resolveServiceMediaUrl } from '../utils/serviceContent';
import './ServiceDescription.css';

const ServiceDescription = ({ service }) => {
  return (
    <div className="service-details-description">
      <div className="service-details-description-primary">
        <p>{service.description}</p>
        {service.image && (
          <div className="service-details-image-wrapper">
            <img
              src={resolveServiceMediaUrl(service.image)}
              alt={service.title}
              className="service-details-image"
            />
          </div>
        )}
      </div>
      {service.descriptionSecondParagraph && (
        <p className="service-details-description-secondary">
          {service.descriptionSecondParagraph}
        </p>
      )}
    </div>
  );
};

export default ServiceDescription;

